import { defineComponent as _defineComponent } from 'vue'
import { IReward } from '../models/reward'
import { KdButton, KdNoData } from 'kuaidong-ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'Rewards',
  props: {
    rewards: null,
    emptyText: { default: '— 当前还没有奖品 —' },
    hideAvatar: { type: Boolean },
    hideDisabledBtn: { type: Boolean }
  },
  emits: ['jump-to-target'],
  setup(__props: any, { emit: emits }) {





async function jumpToTarget(reward: IReward) {
  await reward.action?.()
  emits('jump-to-target', reward)
}

return { __sfc: true,emits, jumpToTarget, KdButton, KdNoData }
}

})